import React, { Component, Fragment } from 'react'

type Props = {
    label: string,
    value: number,
    cityName: string,
    averageValue: number,
    invertColors?: boolean,
    valueFormatter?: Function
}
class MetricVsAverage extends Component<Props> {
  static defaultProps = {
    cityName: 'city'
  }

  render() {
    const {
      label,
      value,
      cityName,
      averageValue,
      invertColors,
      valueFormatter
    } = this.props

    // calculate the difference between the value and the average
    const averageValueDiff = ((value/averageValue) * 100) - 100

    // compute the color code to use based on the diff
    // green means good
    // red means bad
    const invert = invertColors ? -1 : 1
    const averageColor = averageValueDiff * invert < -5
      ? 'red'
      : averageValueDiff * invert < 5
        ? 'gray'
        : 'green'

    const formattedValue = valueFormatter
      ? valueFormatter(value)
      : value

    const formattedAverage = valueFormatter
      ? valueFormatter(averageValue)
      : averageValue

    return (
      <Fragment>
        <div className='tc v-btm w-50 dib'>
          <div className={`f2 mv1 ${averageColor}`}>
            <span>{formattedValue}</span>
          </div>
          <div className='f5 gray'>{label}</div>
        </div>

        <div className='tc v-btm w-50 dib'>
          <div className='f3 mv1'>
            <span className='v-mid'>{formattedAverage}</span>
          </div>
          <div className='f5 gray'>
            {cityName} average
          </div>
        </div>
      </Fragment>
    )
  }
}

export default MetricVsAverage



// WEBPACK FOOTER //
// ./src/components/MetricVsAverage/MetricVsAverage.js